import React, { memo } from 'react';

function SvgGradients() {
  return (
    <svg style={{ position: 'absolute', left: '-9999px' }}>
      <defs>
        <linearGradient id="brightGradient" x1="0" y1="1" x2="1" y2="0">
          <stop stopColor="#90bbf6" offset="0%" />
          <stop stopColor="#918eff" offset="100%" />
        </linearGradient>
        <linearGradient id="warningGradient" x1="0" y1="1" x2="1.2" y2="-0.2">
          <stop stopColor="#EF2D56" offset="0%" />
          <stop stopColor="#918EFF" offset="60%" />
          <stop stopColor="#619EF3" offset="100%" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const memoizedSvgGradients = memo(SvgGradients);

export { memoizedSvgGradients as SvgGradients };
